import {
  CREATEORUPDATEWALLETOWNER_SUCCESS,
  CREATEORUPDATEWALLETOWNER_FAILED,
  RESET_CREATEORUPDATEWALLETOWNER,
  LOADING_CREATEORUPDATEWALLETOWNER,
  NETWORK_ERROR_CREATEORUPDATEWALLETOWNER,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetcreateOrUpdateWalletOwner = () => {
  return { type: RESET_CREATEORUPDATEWALLETOWNER };
};

const createOrUpdateWalletOwner = (userData, authTokenIs) => async (dispatch) => {
  console.log({ userData })
  dispatch({ type: LOADING_CREATEORUPDATEWALLETOWNER });
  await adminServices
    .post("createOrUpdateWalletOwner", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(createOrUpdateWalletOwnerSuccess(res.data));
          break;
        default:
          dispatch(createOrUpdateWalletOwnerFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({
        type: NETWORK_ERROR_CREATEORUPDATEWALLETOWNER,
        payload: err,
      });
    });
};
function createOrUpdateWalletOwnerSuccess(data) {
  return {
    type: CREATEORUPDATEWALLETOWNER_SUCCESS,
    payload: data,
  };
}
function createOrUpdateWalletOwnerFailed(data) {
  return {
    type: CREATEORUPDATEWALLETOWNER_FAILED,
    payload: data,
  };
}

export { resetcreateOrUpdateWalletOwner, createOrUpdateWalletOwner };
